import CreditBadge from "@/components/CreditBadge";
import { theme } from "@/lib/theme";
import { cn } from "@/lib/utils";

interface CostBreakdownTableProps {
  estimatedCostCents: number;
  creditBalanceCents: number | null;
  amountToChargeCents: number;
  className?: string;
}

export default function CostBreakdownTable({
  estimatedCostCents,
  creditBalanceCents,
  amountToChargeCents,
  className,
}: CostBreakdownTableProps) {
  const estimatedCost = (estimatedCostCents / 100).toFixed(2);
  const creditBalance = creditBalanceCents !== null ? (creditBalanceCents / 100).toFixed(2) : null;
  const amountToCharge = (amountToChargeCents / 100).toFixed(2);

  return (
    <div className={cn("space-y-2", className)}>
      <h4 className="text-sm font-semibold text-gray-900 dark:text-white">Cost Breakdown:</h4>
      <div className={cn("rounded-lg border-2 border-gray-900 dark:border-gray-300 p-4 space-y-2", theme.shadows.neubrutalismSm)}>
        <div className="flex items-center justify-between">
          <span className="text-sm text-gray-700 dark:text-gray-300">Estimated cost:</span>
          <span className="text-sm font-semibold text-gray-900 dark:text-white">${estimatedCost}</span>
        </div>
        <div className="flex items-center justify-between">
          <span className="text-sm text-gray-700 dark:text-gray-300">Your credits:</span>
          {creditBalance !== null ? (
            <CreditBadge balanceCents={creditBalanceCents!} />
          ) : (
            <span className="text-sm text-gray-500 dark:text-gray-400">N/A</span>
          )}
        </div>
        <div className="flex items-center justify-between pt-2 border-t-2 border-gray-900 dark:border-gray-300">
          <span className="text-sm font-semibold text-gray-900 dark:text-white">Amount to charge:</span>
          <span className="text-sm font-semibold text-gray-900 dark:text-white">${amountToCharge}</span>
        </div>
      </div>
    </div>
  );
}

